module.exports = __webpack_public_path__ + "img/wb_o_office-mayo.e100d075.svg";